import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { Button, Flex, H3, Modal, P } from "orcs-design-system";
import PropTypes from "prop-types";
import { deletePublicAPICredential } from "src/queries/mutations/apiKeys.graphql";

const DeleteSecretModal = ({ visible, clientId, onHideModal, refetch }) => {
  const [deletePublicApiKey] = useMutation(deletePublicAPICredential);
  const [deleteError, setDeleteError] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [cancelDisabled, setCancelDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const onCloseModal = () => {
    setDeleteError(false);
    setDeleteSuccess(false);
    setLoading(false);
    onHideModal();
  };
  const handleDelete = async () => {
    setCancelDisabled(true);
    setLoading(true);

    try {
      const { data } = await deletePublicApiKey({ variables: { clientId } });

      if (data?.result) {
        setDeleteSuccess(true);
        refetch();
      } else {
        setDeleteError(true);
      }
    } catch {
      setDeleteError(true);
    } finally {
      setLoading(false);
      setCancelDisabled(false);
    }
  };
  const closeLabel = deleteSuccess ? "Close" : "Cancel";
  return (
    <Modal
      visible={visible}
      onClose={onCloseModal}
      headerContent={<H3>Delete API Key</H3>}
      footerContent={
        <Flex gap="s">
          {!deleteError && !deleteSuccess && (
            <Button variant="danger" onClick={handleDelete} isLoading={loading}>
              Delete API Key
            </Button>
          )}
          <Button onClick={onCloseModal} disabled={cancelDisabled}>
            {closeLabel}
          </Button>
        </Flex>
      }
    >
      {!deleteError && !deleteSuccess && (
        <P mb="r" mt="r">
          Are you sure you want to delete the API key? This action can not be
          undone.
        </P>
      )}
      {deleteError && !deleteSuccess && (
        <P mb="r" mt="r">
          An error has occurred while deleting the API key. Please try again.
        </P>
      )}
      {deleteSuccess && (
        <P mb="r" mt="r">
          The API key has been deleted successfully.
        </P>
      )}
    </Modal>
  );
};

DeleteSecretModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  onHideModal: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};
export default DeleteSecretModal;
